import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';

export type SecurityCardProps = {
  className?: string;
  head: React.ReactNode;
  text: React.ReactNode | string;
  imageSrc: string;
  caution?: React.ReactNode;
};

export const SecurityCard: React.FC<SecurityCardProps> = ({
  className,
  head,
  text,
  imageSrc,
  caution,
}) => {
  return (
    <>
      <div
        css={css`
          background: #fff;
          padding: 25px 20px 20px;
          margin: 0 auto;
          box-shadow: 0px 4px 16px #2c28281c;
          border-radius: 12px;

          @media ${getScreen('pc')} {
            padding: 32px;
            min-height: 200px;
            display: grid;
            grid-template-areas:
              'icon .'
              'icon head'
              'icon text'
              'icon .';
            grid-template-rows: 1fr auto auto 1fr;
            gap: 0 32px;
          }
        `}
        className={className}
      >
        <div
          css={css`
            grid-area: icon;
            width: max-content;
            margin: 0 auto 15px;

            @media ${getScreen('pc')} {
              margin: 0;
              align-self: center;
            }
          `}
        >
          <img src={imageSrc} alt="" width="92" height="92" />
        </div>
        <p
          css={css`
            grid-area: head;
            text-align: center;
            font: normal normal 500 16px/24px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.64px;
            color: #00b3a7;

            @media ${getScreen('pc')} {
              text-align: left;
            }

            br {
              @media ${getScreen('pc')} {
                display: none;
              }
            }
          `}
        >
          {head}
        </p>
        <p
          css={css`
            grid-area: text;
            font: normal normal normal 12px/20px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.29px;
            color: #444b57;
            margin-top: 10px;

            @media ${getScreen('pc')} {
              margin-top: 12px;
            }
          `}
        >
          {text}
        </p>
      </div>
      {caution && (
        <p
          css={css`
            font: normal normal normal 10px/14px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.4px;
            color: #444b57;
            margin-top: 8px;

            a {
              text-decoration: underline;
            }
          `}
        >
          {caution}
        </p>
      )}
    </>
  );
};
